<template>
  <layout>
    <page-header :actions="actions" :header="$t('coupons.title')" />
    <div class="content">
      <admin-table v-bind="tableProps">
        <template #multiuse="{ item }">
          <i
            :class="{
              'icon-check': item.multiuse,
              'icon-cross3': !item.multiuse,
            }"
          />
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import CouponsApi from './CouponsApi'

const resourceBase = 'coupons'

export default {
  name: 'CouponsIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder() {
          return new CouponsApi().setParameters({
            context: 'list',
          })
        },
        sortBy: 'created_at',
        sortDesc: true,
        columns: [
          {
            key: 'id',
            label: this.$t('coupons.id'),
            sortable: true,
          },
          {
            key: 'code',
            label: this.$t('coupons.code'),
            sortable: true,
          },
          {
            key: 'discount_type',
            label: this.$t('coupons.discount_type'),
            sortable: true,
          },
          {
            key: 'discount_value',
            label: this.$t('coupons.discount_value'),
          },
          {
            key: 'multiuse',
            label: this.$t('coupons.multi_use'),
          },
          {
            key: 'created_at',
            label: this.$t('coupons.created_at'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // eslint-disable-next-line no-unused-vars
        rowActions: () => {
          let actions = []

          if (this.$allows(`${resourceBase}.update`)) {
            actions.push('edit')
          }
          if (this.$allows(`${resourceBase}.delete`)) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },

        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'query',
            placeholder: this.$t('coupons.code'),
          },
        ],
        searchData: {
          query: null,
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      const actions = []
      if (this.$allows(`${resourceBase}.create`)) {
        actions.push({
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        })
      }
      return actions
    },
  },
}
</script>
